<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div
      class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-48 px-4 overflow-hidden"
      style="padding-bottom: 20rem"
    >
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Lista de proyectos
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
            >{{ filteredProjects.length }}</span
          >
        </h3>
        <button
          class="border-2 rounded border-gray-700"
          @click="changeFormOrder"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
        <button
          class="ml-2 px-3 py-1 bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white border border-secondary-color-dark hover:border-transparent rounded"
          @click="openAddModal()"
        >
          Crear proyecto
        </button>
        <!-- <div
          class="rounded-full cursor-pointer bg-primary-color hover:bg-primary-color-dark p-1 ml-2"
          @click="openAddModal()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current text-white h-6 w-6"
            viewBox="0 0 24 24"
          >
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div> -->
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de proyectos"
        class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />

      <div class="w-full">
        <div class="w-full relative">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 mb-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
            @change="updateselectProject()"
          >
            <option selected value="-1">Todos</option>
            <template v-for="category in categories">
              <option :key="category.id" :value="category.id">
                {{ category.nombre }}
              </option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="w-full flex">
        <button
          v-on:click="
            (statusFilter = 'TODOS'), filteredProjects, updateselectProject()
          "
          class="w-full hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilter === 'TODOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          Todos {{ filteredByAll.length }}
        </button>
      </div>
      <div class="w-full flex">
        <button
          v-on:click="
            (statusFilter = 'NO REVISADOS'),
              filteredProjects,
              updateselectProject()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilter === 'NO REVISADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          EN PROCESOS {{ filteredByOpen.length }}
        </button>
        <button
          v-on:click="
            (statusFilter = 'RECHAZADOS'),
              filteredProjects,
              updateselectProject()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilter === 'RECHAZADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          RECHAZADOS {{ filteredByCanceled.length }}
        </button>
      </div>
      <div class="w-full flex pb-2">
        <button
          v-on:click="
            (statusFilter = 'EN REVISIÓN'),
              filteredProjects,
              updateselectProject()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-l border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilter === 'EN REVISIÓN'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          EN REVISIÓN {{ filteredByAssigned.length }}
        </button>
        <button
          v-on:click="
            (statusFilter = 'APROBADOS'),
              filteredProjects,
              updateselectProject()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilter === 'APROBADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          APROBADOS {{ filteredByAttended.length }}
        </button>
      </div>

      <div class="h-full overflow-auto">
        <div
          v-for="event in filteredProjects"
          :key="event.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{ 'bg-secondary-color': event.id === currentProject.id }"
          @click="selectProject(event)"
        >
          <img
            :src="event.path_media_folder"
            class="h-12 w-12 object-cover"
            @error="loadDefaultImg"
          />
          <div class="flex flex-col flex-grow ml-2">
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ event.nombre }}</span
            >
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ event.fecha_creacion | moment("DD/MM/YYYY hh:mm A") }}</span
            >
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-sm group-hover:text-gray-700"
              >{{ event.institucion }}</span
            >
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-sm group-hover:text-gray-700"
              >F-{{ event.id }} {{ event.status }}</span
            >
          </div>
          <div
            v-if="event.en_pausa === true"
            class="flex self-start justify-self-end text-xs"
          >
            <div
              class="px-3 py-1 rounded-full border-2 border-blue-700 text-xs text-white bg-blue-500"
            >
              En pausa
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="w-full pb-2 text-right">
            <a
              v-if="currentProject.geometria !== null"
              id="downGeojson"
              v-on:click="toGeojsonFile()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >Geojson</a>

            <a
              v-if="currentProject.geometria !== null"
              id="downKML"
              v-on:click="toKMLFile()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >KML</a>         

            <a
              v-if="currentProject.geometria !== null"
              id="downSHP"
              v-on:click="toSHPFile()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >Shapefile (zip)</a> 
            <button
              v-if="downloadActive && currentProject.status === 'APROBADO'"
              v-on:click="showingConfirmDownload = true"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Descargar Fichas
            </button>
            <button
              v-on:click="exportPDF()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Descargar Reporte
            </button>
            <button
              v-if="
                currentProject.status === 'NO REVISADO' ||
                currentProject.status === 'EN REVISIÓN'
              "
              v-on:click="newChatModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Mensajes
            </button>
            <button
              v-if="currentProject.status !== 'APROBADO'"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="openEditModal()"
            >
              Editar
            </button>
            <button
              v-if="currentProject.activo"
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingDeactivationConfirm = true"
            >
              Desactivar
            </button>
            <button
              v-if="currentProject.activo === false"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="showingActivationConfirm = true"
            >
              Activar
            </button>
            <button
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingDeleteConfirm = true"
            >
              Eliminar
            </button>
          </div>
          <div class="flex w-full">
            <div class="w-full">
              <div class="text-left font-bold text-sm text-gray-700">
                Ubicación:
              </div>
              <div class="flex">
                <div class="h-80 w-full">
                  <l-map
                    ref="map"
                    class="h-full w-full z-0"
                    :zoom="zoom"
                    :minZoom="4"
                    :center="center"
                    :options="{ zoomControl: true }"
                    @ready="onMapReady"
                  >
                    <l-tile-layer
                      :url="urlBasemap"
                      :attribution="attribution"
                    ></l-tile-layer>
                    <l-geo-json v-if="geojsonRouter" :geojson="geojsonRouter" />
                    <!-- <l-marker :lat-lng="center" :visible="showMarker"></l-marker> -->
                  </l-map>
                </div>
              </div>
            </div>
          </div>

          <!--seccion de informacion -->
          <div class="flex w-full">
            <div
              class="flex flex-col w-11/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
              <p
                class="pb-1 pt-2 text-sm text-center font-bold tracking-widest"
              >
                Información del proyecto
              </p>

              <div class="flex items-center">
                <div class="flex items-center w-1/2 text-left text-xs">
                  <div class="flex items-center w-full text-left text-xs">
                    <div
                      v-if="currentProject.status === 'NO REVISADO'"
                      class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} EN PROCESO
                    </div>
                    <div
                      v-if="currentProject.status === 'RECHAZADO'"
                      class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div
                      v-if="currentProject.status === 'EN REVISIÓN'"
                      class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div
                      v-if="currentProject.status === 'APROBADO'"
                      class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div class="pl-2">
                      <div
                        v-if="currentProject.activo === true"
                        class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                      >
                        Activo
                      </div>
                      <div
                        v-if="currentProject.activo === false"
                        class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                      >
                        Desactivado
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2 text-right text-xs text-gray-900">
                  {{
                    currentProject.fecha_levantamiento
                      | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>
              <br>
              <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre del proyecto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Institución:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.institucion }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Líder de proyecto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.lider }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Descripción:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.descripcion }}
                </div>
              </div>

<!--               <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Objetivo:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.objetivo }}
                </div>
              </div> -->

<!--               <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold"
                    >Especificaciones de la fotografía:</span
                  >
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.especificaciones_multimedia }}
                </div>
              </div> -->

<!--               <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Producto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.producto }}
                </div>
              </div> -->

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
                v-if="currentProject.activo === true"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Creado por:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre_propietario }}
                  {{ currentProject.apellido_propietario }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.activo === true"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Fecha de creación:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{
                    currentProject.fecha_creacion | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
                v-if="currentProject.activo === false"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Desactivado por:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre_curador_desactivate }}
                  {{ currentProject.apellido_curador_desactivate }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
                v-if="currentProject.activo === false"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Fecha de desactivación:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{
                    currentProject.fecha_desactivacion
                      | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
                v-if="currentProject.id_curador !== null"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span
                    class="font-bold"
                    v-if="currentProject.status !== 'NO REVISADO'"
                    >Revisado por:</span
                  >
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs ml-2 mb-2 text-left"
                >
                  {{ currentProject.nombre_curador }}
                  {{ currentProject.apellido_curador }}
                </div>
              </div>

              <div
                v-if="currentProject.file_type == 'video/mp4'"
                class="flex justify-center py-2 w-full"
              >
                <video
                  :src="currentProject.path_media_folder"
                  width="640"
                  height="480"
                  controls
                  controlslist="nodownload"
                />
              </div>
              <div class="flex justify-center py-2 w-8/12 mx-auto">
                <v-lazy-image
                  v-if="currentProject.imagen !== null"
                  :src="currentProject.path_media_folder"
                />
              </div>

            </div>
          </div>
          <!--/seccion de informacion -->

            <!-- sección de ficha -->
            <div class="flex w-full">
            <div
              class="flex flex-col w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >

              <p
                v-if="currentProject.ficha_proyecto"
                class="pb-1 pt-2 text-sm text-center font-bold tracking-widest"
              >
                Ficha de información
              </p>
              <br>
              <div
                v-for="one_question in currentQuestions"
                :key="one_question.id"
              >
                <div v-if="one_question.texto != null">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    >{{ one_question.id_pregunta }}.-
                    {{ one_question.texto }}
                    <template v-if="one_question.nota_para_registrante != ''">
                      ({{ one_question.nota_para_registrante }})
                    </template>
                  </label>

                  <div style="padding-left:20px;" >
                  <div v-if="one_question.tipo === 'ABIERTA'">
                    <input 
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      name="question"
                      value=""
                      disabled
                    />
                  </div>

                  <template v-if="one_question.tipo == 'SELECCION'">
                    <template v-for="(opt, index) in one_question.opciones">
                      <div class="flex items-center text-gray-700 font-bold">
                        <input
                          class="mr-2 leading-tight"
                          type="radio"
                          name="question"
                          disabled
                        />
                        <span>
                          {{ opt }}
                        </span>
                      </div>
                    </template>
                  </template>

                  <template v-if="one_question.tipo == 'MULTISELECCION'">
                    <template
                      v-for="(opt, index) in one_question.opciones">
                      <div
                        class="flex items-center text-gray-700 font-bold">
                        <input
                          class="mr-2 leading-tight"
                          type="checkbox"
                          name="question"
                          disabled
                        />
                        <span>
                          {{opt}}
                        </span>
                      </div>
                    </template>
                  </template>                     

                  <template v-if="one_question.tipo == 'SELECCION_CONDICIONAL'">
                    <template v-for="(opt, index) in one_question.opciones">
                      <div class="flex items-center text-gray-700 font-bold">
                        <input
                          class="mr-2 leading-tight"
                          type="radio"
                          name="question"
                          :value="opt"
                          disabled
                        />
                        <span>
                          {{ opt }}
                        </span>
                      </div>
                    </template>

                    <template
                      v-for="(opt, index) in one_question.pregunta_condicion"
                    >
                      <label
                        class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                        >{{ opt.id }}.- <span style="color: #909696">({{ index }})</span>
                        {{ opt.texto }}
                        
                        <template v-if="opt.nota_para_registrante != ''">
                          ({{ opt.nota_para_registrante }})
                        </template>
                      </label>

                      <template v-if="opt.tipo == 'SELECCION'">
                        <template v-for="(opt1, index) in opt.opciones">
                          <div
                            class="flex items-center text-gray-700 font-bold"
                          >
                            <input
                              class="mr-2 leading-tight"
                              type="radio"
                              name="question"
                              :value="opt"
                              disabled
                            />
                            <span>
                              {{ opt1 }}
                            </span>
                          </div>
                        </template>
                      </template>

                      <div v-if="opt.tipo === 'ABIERTA'">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          disabled
                        />
                      </div>

                      <template v-if="opt.tipo == 'CAMPOS'">
                        <template v-for="(opt1, index) in opt.campos">
                          <div class="flex w-full items-center justify-center">
                            <label
                              class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ opt1.texto }}</label
                            >
                            <input
                              class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              value=""
                              disabled
                            />
                          </div>
                        </template>
                      </template>
                    </template>
                  </template>

                  <template v-if="one_question.tipo == 'CAMPOS'">
                    <template v-for="(opt, index) in one_question.campos">
                      <div class="flex w-full items-center justify-center">
                        <label
                          class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ opt.texto }}</label
                        >
                        <input
                          class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          disabled
                        />
                      </div>
                    </template>
                  </template>

                  <template v-if="one_question.hasOwnProperty('subpregunta')">
                    <template v-for="(opt, index) in one_question.subpregunta">
                      <label
                        class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                        >{{ opt.id_pregunta }}.-
                        {{ opt.texto }}
                        <template v-if="opt.nota_para_registrante != ''">
                          ({{ opt.nota_para_registrante }})
                        </template>
                      </label>
                      <div v-if="opt.tipo === 'ABIERTA'">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          disabled
                        />
                      </div>

                      <template v-if="opt.tipo == 'SELECCION'">
                        <template v-for="(opt, index) in opt.opciones">
                          <div
                            class="flex items-center text-gray-700 font-bold"
                          >
                            <input
                              class="mr-2 leading-tight"
                              type="radio"
                              name="question"
                              :value="opt"
                              disabled
                            />
                            <span>
                              {{ opt }}
                            </span>
                          </div>
                        </template>
                      </template>

                      <template v-if="opt.tipo == 'CAMPOS'">
                        <template v-for="(opt, index) in opt.campos">
                          <div class="flex w-full items-center justify-center">
                            <label
                              class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ opt.texto }}</label
                            >
                            <input
                              class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              value=""
                              disabled
                            />
                          </div>
                        </template>
                      </template>
                    </template>
                  </template>
                </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /sección de ficha -->

          <div class="flex w-full pb-6">
            <div
              v-if="dataLoaded"
              class="w-2/3 h-80 mx-auto py-4 px-4 overflow-hidden"
            >
              <div>
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por estado</span
                >
              </div>
              <doughnut-lev-chart
                :chartData="statusData"
                :options="doughnutChartOptions"
                :css-classes="'w-1/2 h-64 py-2 mx-auto'"
              ></doughnut-lev-chart>
            </div>
          </div>

          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full mx-4 py-4 px-4">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por fechas</span
                >
              </div>
              <div class="flex w-full">
                <div class="w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    for="fechaInicio"
                    >Fecha inicial</label
                  >
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="fechaInicio"
                    type="date"
                    name="fechaInicio"
                    v-model="fechaInicio"
                    :max="startMaxDate"
                    @change="checkStartCalendar"
                  />
                </div>

                <div class="w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    for="fechaFin"
                    >Fecha final</label
                  >
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="fechaFin"
                    type="date"
                    name="fechaFin"
                    v-model="fechaFin"
                    :min="endMinDate"
                    :max="endMaxDate"
                    @change="checkEndCalendar"
                  />
                </div>
              </div>
              <bar-chart
                :chartData="dataByDate"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByDateLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full mx-4 py-4 px-4">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por municipios</span
                >
              </div>

              <bar-chart
                :chartData="dataByMun"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByMunLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full mx-4 py-4 px-4 overflow-hidden">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por año</span
                >
              </div>
              <div class="flex w-full">
                <div class="w-1/3 px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    for="selectedYear"
                    >Seleccionar año</label
                  >
                  <div class="relative">
                    <select
                      v-model="selectedYear"
                      name="selectedYear"
                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      @change="fetchStatisticsByYear"
                    >
                      <template v-for="(year, index) in years">
                        <option :value="year" :key="index">{{ year }}</option>
                      </template>
                    </select>
                    <div
                      class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                    >
                      <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <bar-chart
                :chartData="dataByYear"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByYearLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex flex-wrap" v-if="dataMediaLoaded">
            <div class="w-full pb-2">
              <span class="font-semibold text-lg tracking-wider"
                >Últimos archivos multimedia agregados</span
              >
            </div>
            <div
              v-for="(media, mediaIndex) in multimediaList"
              :key="mediaIndex"
              class="flex w-auto h-88 px-2 pb-4"
              style="flex: 1 0 21%"
            >
              <img
                v-if="media.mimeType.includes('image')"
                :src="replaceURL(media.fileName)"
                class="h-full w-full object-contain"
                alt=""
              />
              <video
                v-if="media.mimeType.includes('video')"
                :src="replaceURL(media.fileName)"
                class="h-full w-full bg-gray-300"
                controls
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>

    <proyect-modal
      :showing="showEventModal"
      :event="modalEvent"
      :aux_event="aux_modalEvent"
      :modalAction="modalAction"
      @close="closeModal"
    ></proyect-modal>

    <raising-chat-modal
      :showing="showCommentsModal"
      @close="showCommentsModal = false"
    ></raising-chat-modal>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Evento guardado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingDeactivationConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea desactivar el proyecto?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deleteProject()"
        >
          Desactivar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingDeactivationConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingActivationConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea activar el proyecto?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deleteProject()"
        >
          Activar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingActivationConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmDownload">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea descargar las fichas de este proyecto?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="downloadRaisingProject()"
        >
          Descargar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmDownload = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDeactivation">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Proyecto desactivado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDeactivation = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessActivation">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Proyecto activado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessActivation = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingDeleteConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Realmente desea eliminar el proyecto? Esta acción no se puede
          deshacer
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="realDeleteProject()"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingDeleteConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Proyecto eliminado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

     <alert-dialog :showing="showingProjectNotEmpty">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          El proyecto no se puede eliminar, tiene fichas asociadas
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingProjectNotEmpty = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>


    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="2000"
      :filename="currentProject.nombre"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="letter"
      pdf-orientation="portrait"
      ref="html2Pdf"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="hasDownloaded($event)"
    >
      <section slot="pdf-content">
          <!-- PDF Content Here -->
          
        <section class="pdf-item">

          <div class="flex w-full pl-4">  
            <div class="flex flex-col w-8/12 px-3 mx-auto my-3 mb-2  bg-gray-400 rounded-lg shadow-xl">
              <div class="flex w-full items-center justify-center pb-4">
                <span>REPORTE GENERADO</span>
              </div>
            </div>
          </div>
          
          <div class="flex w-full pl-4">
            <div
              class="flex flex-col w-full px-4"
            >
              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre del proyecto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Folio:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  F-{{ currentProject.id }} {{ currentProject.status }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Estado:</span>
                </div>
                <div
                  v-if="currentProject.activo === true"
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  Activo
                </div>
                <div
                  v-if="currentProject.activo === false"
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  Desactivado
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Institución:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.institucion }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Líder de proyecto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.lider }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Descripción:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.descripcion }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Objetivo:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.objetivo }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold"
                    >Especificaciones de la fotografía:</span
                  >
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.especificaciones_multimedia }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Producto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.producto }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Creado por:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre_propietario }}
                  {{ currentProject.apellido_propietario }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Fecha de creación:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{
                    currentProject.fecha_creacion | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>
            </div>
          </div>

        </section>  

        <div class="html2pdf__page-break"/>
        <section class="pdf-item">
          
          <div class="flex w-full">
            <div class="flex flex-col w-full mx-4 px-4">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por estado</span
                >
              </div>
              <div
                v-if="dataLoaded"
                class="w-2/3 h-80 mx-auto py-4 px-4 overflow-hidden"
              >
                <doughnut-lev-chart
                  :chartData="statusData"
                  :options="doughnutChartOptions"
                  :css-classes="'w-96 h-64 py-2 mx-auto'"
                ></doughnut-lev-chart>
              </div>
            </div>
          </div>

          <div class="flex w-full">
            <div class="flex flex-col w-full mx-4 px-4">
              <div class="w-full">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por dias ({{ fechaInicio | moment('DD/MM/YYYY') }} - {{ fechaFin | moment('DD/MM/YYYY') }})</span
                >
              </div>
              <div class="w-full pb-2">
                <span class="text-xs tracking-wider"
                  >Total {{totalByMonth}}</span
                >
              </div>
              <bar-chart
                :chartData="dataByDate"
                :options="barChartOptions"
                :css-classes="'w-3/4 h-64 py-2 mx-auto'"
                v-if="dataByDateLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex w-full">
            <div class="flex flex-col w-full mx-4 px-4">
              <div class="w-full">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por año ( {{ selectedYear }} )</span
                >
              </div>
              <div class="w-full pb-2">
                <span class="text-xs tracking-wider"
                  >Total {{totalByYear}}</span
                >
              </div>
              <bar-chart
                :chartData="dataByYear"
                :options="barChartOptions"
                :css-classes="'w-96 h-64 py-2 mx-auto'"
                v-if="dataByYearLoaded"
              >
              </bar-chart>
            </div>
          </div>

          </section>
        
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import ProyectModal from "./ProyectModal";
import AlertDialog from "./AlertDialog";
import moment from "moment";
import VueHtml2pdf from 'vue-html2pdf'

import L from "leaflet";
import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import "leaflet-kmz/dist/leaflet-kmz";
import "leaflet-kml/L.KML";
import { Icon } from "leaflet";
import EventBus from "../event-bus";
import RaisingChatModal from "./RaisingChatModal";
import BarChart from "./BarChart.vue";
import DoughnutLevChart from "./DoughnutLevChart.vue";
import jsPDF from "jspdf";
import tokml from "tokml"
import shpwrite from "shp-write"

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "projects-list",
  data() {
    return {
      geojsonRouter: null,
      projects: [],
      search: "",
      currentQuestions: [],
      currentProject: {},
      showEventModal: false,
      showingSuccess: false,
      showingActivationConfirm: false,
      showingDeactivationConfirm: false,
      showingConfirmDownload: false,
      downloadActive: false,
      showingError: false,
      showingSuccessDeactivation: false,
      showingSuccessActivation: false,
      showCommentsModal: false,
      showingDeleteConfirm: false,
      showingSuccessDelete: false,
      showingProjectNotEmpty: false,
      statusFilter: "TODOS",
      modalEvent: {},
      aux_modalEvent: {},
      modalAction: "",
      email: localStorage.getItem("email"),
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      configDownload: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
        responseType: "blob",
      },
      showingCalendar: false,
      // showDuplicateEvents: false,
      // duplicateEvents: [],
      zoom: 12,
      center: [20.58651, -89.01501],
      //showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false,
      },
      formOrder: "upward",
      leafletMap: null,
      currentRouteLayer: null,
      kmzParser: null,
      layerKml: null,
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      categoryFilter: "-1",
      categories: [
        {
          id: 0,
          nombre: "Desactivado",
        },
        {
          id: 1,
          nombre: "Activo",
        },
      ],
      barChartOptions: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
              },
            },
          ],
        },
      },
      doughnutChartOptions: {
        legend: {
          display: true,
          labels: {
            fontSize: 14,
            fontStyle: "bold",
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
      fechaInicio: null,
      fechaFin: null,
      dataByDate: {},
      dataByDateLoaded: false,
      startMaxDate: moment(new Date()).format("YYYY-MM-DD"),
      endMinDate: "",
      endMaxDate: moment(new Date()).format("YYYY-MM-DD"),
      multimediaList: [],
      dataMediaLoaded: false,
      firstYear: null,
      selectedYear: null,
      dataByYear: {},
      dataByYearLoaded: false,
      years: [],
      statusData: {},
      dataLoaded: false,
      dataByMun: {},
      dataByMunLoaded: false,
      totalByYear: 0,
      totalByMonth: 0
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LTileLayer,
    ProyectModal,
    AlertDialog,
    RaisingChatModal,
    BarChart,
    DoughnutLevChart,
    VueHtml2pdf
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.name) {
      let id = this.$route.query.id.toString();
      let name = this.$route.query.name.toString();
      this.search = `${id} ${name}`;
    }

    let endDate = new Date();

    let startDate = new Date();

    startDate.setMonth(startDate.getMonth() - 3);

    this.fechaInicio = moment(startDate).format("YYYY-MM-DD");
    this.fechaFin = moment(endDate).format("YYYY-MM-DD");

    EventBus.$emit("updateNotification", {});
    this.fetchProjects();

    this.selectedYear = new Date().getFullYear();
  },
  methods: {
    updateselectProject() {
      if (this.filteredProjects.length > 0) {
        this.selectProject(this.filteredProjects[0]);
      }
    },
    onMapReady: function () {
      this.$nextTick(() => {
        let that = this;
        const map = this.$refs.map.mapObject;
        //esri.basemapLayer("Topographic").addTo(map);
        this.leafletMap = map;

        this.kmzParser = new L.KMZParser({
          onKMZLoaded: function (layer, name) {
            that.geojsonRouter = null;

            if (that.layerKmz != null) {
              map.removeLayer(that.layerKmz);
              that.layerKmz = null;
            }

            that.layerKmz = layer;
            layer.addTo(map);
          },
        });
      });
    },
    fetchProjects() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/projects/getProjects",
          {
            email: localStorage.getItem("email"),
            category: localStorage.getItem("category"),
          },
          this.config
        )
        .then((response) => {
          this.projects = response.data.proyectos;
          this.$root.$emit("hideLoading");
          if (this.filteredProjects.length > 0) {
            this.selectProject(this.filteredProjects[0]);
          }
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    showPolygonInMap() {
      if (this.currentProject.geometria !== null) {
        if (this.currentProject.kml != null) {
          const type = this.currentProject.kml.split(".")[1];
          if (type == "kml") {
            this.resetFileGeometryInMap();
            this.geojsonRouter = null;
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", () => {
              this.loadKml(oReq.responseText);
            });
            oReq.open("GET", "../apidev/" + this.currentProject.kml);
            oReq.send();
          }

          if (type == "kmz") {
            this.resetFileGeometryInMap();
            this.kmzParser.load("../apidev/" + this.currentProject.kml);
          }
        } else {
          this.resetFileGeometryInMap();
          this.geojsonRouter = this.currentProject.geometria;
          if (this.geojsonRouter) {
            let boundingBoxGeojson = L.geoJSON(this.geojsonRouter);
            let boundingBox = boundingBoxGeojson.getBounds();
            this.$refs.map.mapObject.fitBounds(boundingBox);
          }
        }
      } else {
        this.resetFileGeometryInMap();
        this.geojsonRouter = null;
      }
    },
    resetFileGeometryInMap() {
      if (this.layerKmz != null) {
        this.leafletMap.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }

      if (this.layerKml != null) {
        this.leafletMap.removeLayer(this.layerKml);
        this.layerKml = null;
      }
    },

    loadKml(text) {
      if (this.leafletMap != null) {
        const parser = new DOMParser();
        this.new_kml = parser.parseFromString(text, "text/xml");
        this.layerKml = new L.KML(this.new_kml);
        this.leafletMap.addLayer(this.layerKml);
      }
    },
    selectProject(event) {
      this.$root.$emit("showLoading");
      this.currentProject = event;
      this.showPolygonInMap();

      if (event.es_notificado != null && event.es_notificado) {
        this.axios
          .post(
            "../apidev/projects/updateNotification",
            {
              id: this.currentProject.id,
            },
            this.config
          )
          .then(() => {
            EventBus.$emit("updateNotification", {});
          })
          .catch((error) => this.catchError(error));
      }

      this.axios
        .post(
          "../apidev/projects/getFichaRespuestasJson",
          {
            id_project: this.currentProject.id,
          },
          this.config
        )
        .then((response) => {
          this.downloadActive = response.data.levantamientos;
          this.currentQuestions = response.data.answers;
          this.$root.$emit("hideLoading");

          this.fetchStatisticsByProject();
          this.fetchMunicipiosByProject();
          this.fetchMediaByProject();

          this.fetchStatistics();

          this.fetchLevantamientoFirstDate();
          this.fetchStatisticsByYear();
        })
        .catch((error) => this.catchError(error));
    },
    closeModal() {
      this.showEventModal = false;
      this.fetchProjects();
    },
    deleteProject() {
      this.$root.$emit("showLoading");

      if( this.currentProject.activo ) {

      this.axios
        .put(
          "../apidev/projects/deactivate/" + this.currentProject.id,
          {
            user_id: localStorage.getItem("user_id"),
            activo: "false"
          },
          this.config
        )
        .then(() => {
          this.currentProject = {};
          this.fetchProjects();
          this.search = "";
          this.showingDeactivationConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingSuccessDeactivation = true;
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
      } else {
        this.axios
          .put(
            "../apidev/projects/deactivate/" + this.currentProject.id,
            {
              user_id: localStorage.getItem("user_id"),
              activo: "true"
            },
            this.config
          )
          .then(() => {
            this.currentProject = {};
            this.fetchProjects();
            this.search = "";
            this.showingActivationConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessActivation = true;
          })
          .catch((error) => {
            this.catchError(error);
            this.showingError = false;
          });
      }

    },
    realDeleteProject() {
      this.$root.$emit("showLoading");
      this.axios
        .delete(
          "../apidev/projects/deleteProject/" + this.currentProject.id,
          {
            user_id: localStorage.getItem("user_id"),
            activo: "false",
          },
          this.config
        )
        .then((response) => {
          if (response["data"]["status"] == "Proyecto eliminado") {
            this.currentProject = {};
            this.fetchProjects();
            this.search = "";
            this.showingDeleteConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessDelete = true;
          }

          if (
            response["data"]["status"] == "El proyecto tiene fichas asociadas"
          ) {
            this.showingDeleteConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingProjectNotEmpty = true;
            
          }
        })
        .catch((error) => {
          console.log("ocurrió un error al eliminar: ", error);
          this.showingDeleteConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },
    openAddModal() {
      this.modalEvent = {
        imagen: "",
      };
      this.modalAction = "add";
      this.showEventModal = true;
    },
    openEditModal() {
      this.modalEvent = Object.assign({}, this.currentProject);
      this.aux_modalEvent = Object.assign({}, this.currentProject);
      this.modalAction = "edit";
      this.showEventModal = true;
    },
    loadDefaultImg(event) {
      event.target.src = "https://via.placeholder.com/80";
    },
    changeFormOrder() {
      this.formOrder = this.formOrder === "upward" ? "downward" : "upward";
    },
    downloadRaisingProject() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/downloads//proyect/exportLevantamientos/",
          {
            user_id: localStorage.getItem("user_id"),
            project_id: this.currentProject.id,
            project_name: this.currentProject.nombre,
          },
          this.configDownload
        )
        .then((response) => {
          const fileName =
            response.headers["content-disposition"].match(/filename=(.*)/)[1];
          var fileUrl = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/zip" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileUrl;
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$root.$emit("hideLoading");
          this.showingConfirmDownload = false;
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    newChatModal() {
      this.showCommentsModal = true;
      EventBus.$emit("showChatModal", {
        raising_id: parseInt(this.currentProject.id),
        is_curador: false,
        menu: "PROYECTO",
      });
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
    fetchStatisticsByProject() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatisticsByProject",
          {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            idProyecto: this.currentProject.id,
          },
          this.config
        )
        .then((response) => {
          let statisticsByDate = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByDate.forEach((statistic) => {
            labelsSet.push(moment(statistic.date).format("DD/MM/YYYY"));
            datasetData.push(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByDate = dataCollection;

          this.dataByDateLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchMunicipiosByProject() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosMunicipioByProject",
          {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            idProyecto: this.currentProject.id,
          },
          this.config
        )
        .then((response) => {
          this.totalByMonth = 0
          let statisticsByMun = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByMun.forEach((statistic) => {
            labelsSet.push(statistic.municipio);
            datasetData.push(statistic.total);
            this.totalByMonth += parseInt(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByMun = dataCollection;

          this.dataByMunLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    checkStartCalendar() {
      this.endMinDate = this.fechaInicio;
      if (this.fechaFin != null) {
        this.fetchStatisticsByProject();
        this.fetchMunicipiosByProject();
      }
    },
    checkEndCalendar() {
      this.startMaxDate = this.fechaFin;
      if (this.fechaInicio !== null) {
        this.fetchStatisticsByProject();
        this.fetchMunicipiosByProject();
      }
    },
    fetchMediaByProject() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosMediaByProject",
          {
            idProyecto: this.currentProject.id,
          },
          this.config
        )
        .then((response) => {
          let medias = response.data.media;
          this.multimediaList = [];
          medias.forEach((media) => {
            let mediaList = JSON.parse(media.media_array);

            mediaList.forEach((multimedia) => {
              this.multimediaList.push(multimedia);
            });
          });

          this.dataMediaLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    replaceURL(path) {
      return path.replace("./", "apidev/");
    },
    fetchStatisticsByYear() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatisticsProjectByYear",
          { year: this.selectedYear, idProyecto: this.currentProject.id },
          this.config
        )
        .then((response) => {
          this.totalByYear = 0;
          let statisticsByDate = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByDate.forEach((statistic) => {
            let monthLabel = moment(statistic.date).format("MMMM");
            monthLabel =
              monthLabel.charAt(0).toUpperCase() + monthLabel.slice(1);
            labelsSet.push(monthLabel);
            datasetData.push(statistic.total);
            this.totalByYear += parseInt(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#C5B791",
                data: datasetData,
              },
            ],
          };

          this.dataByYear = dataCollection;

          this.dataByYearLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchLevantamientoFirstDate() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getProjectLevantamientoFirstDate",
          { idProyecto: this.currentProject.id },
          this.config
        )
        .then((response) => {
          if (response.data.firstdate.length > 0) {
            let firstDate = new Date(response.data.firstdate[0].date);
            this.firstYear = firstDate.getFullYear();

            let yearDifference = this.selectedYear - this.firstYear;

            for (let index = 0; index <= yearDifference; index++) {
              this.years.push(this.selectedYear - index);
            }

            this.years.sort();
          }
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchStatistics() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatusByProject",
          { idProyecto: this.currentProject.id },
          this.config
        )
        .then((response) => {
          let statusArray = response.data.status;
          let data = [];
          let dataLabels = [];
          let dataColors = [];
          statusArray.forEach((status) => {
            dataLabels.push(`${status.status}: ${status.total}`);
            data.push(status.total);

            switch (status.status) {
              case "NO REVISADO":
                dataColors.push("#00aedb");
                break;
              case "APROBADO":
                dataColors.push("#00b159");
                break;
              case "EN REVISIÓN":
                dataColors.push("#ffc425");
                break;
              case "RECHAZADO":
                dataColors.push("#d11141");
                break;
              default:
                break;
            }
          });

          let dataCollection = {
            labels: dataLabels,
            datasets: [
              {
                backgroundColor: dataColors,
                pointBackgroundColor: "white",
                borderWidth: 1,
                pointBorderColor: "#249EBF",
                data: data,
              },
            ],
          };

          this.statusData = dataCollection;

          this.dataLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    exportPDF() {
      this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload (){
      this.$root.$emit("showLoading");
    },
    async hasDownloaded (){
      this.$root.$emit("hideLoading");
    },
     toGeojsonFile(){
      console.log("toGeojsonFile", this.currentProject)
      let geojsonObject = this.currentProject.geometria

      let geojsonProperties = {}
      geojsonProperties["proyecto"]     = this.currentProject.nombre;
      geojsonProperties["descripción"]       = this.currentProject.descripcion; 
      geojsonProperties["institucion"]       = this.currentProject.institucion; 
      geojsonProperties["fecha"]        = new Date(this.currentProject.fecha_creacion);

      this.currentProject.geometria.properties = geojsonProperties

      var convertedData = 'text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(geojsonObject)); //encodeURIComponent recibe el geojson como texto
      document.getElementById('downGeojson').setAttribute('href', 'data:' + convertedData);      
      document.getElementById('downGeojson').setAttribute('download',this.currentProject.nombre+'.geojson');      

    },
    toKMLFile(){
      console.log("toKMLFile")
      console.log(this.geojsonGeometries)
      let geojsonObject = this.currentProject.geometria
      var kml = tokml(geojsonObject); //tokml recibe el geojson como objecto
      var convertedData = 'application/xml;charset=utf-8,' + encodeURIComponent(kml);

      // if you want to use the official MIME type for KML
      // var convertedData = 'application/vnd.google-earth.kml+xml;charset=utf-8,'+ 
      // encodeURIComponent(kml);

      document.getElementById('downKML').setAttribute('href', 'data:' + convertedData); 
      document.getElementById('downKML').setAttribute('download', this.currentProject.nombre+'.kml');
    },
    toSHPFile(){
      console.log("toSHPFile")
      var options = {
          folder: this.currentProject.nombre,
          types: {
              point: 'puntos',
              polygon: 'polígonos',
              line: 'líneas'
          }
      }

      let info = {
        "type": "FeatureCollection",
        "features": [this.currentProject.geometria]
      }
      // a GeoJSON bridge for features
      shpwrite.download(info, options) //shpwrite recibe el geojson como objeto
    },
  },
  computed: {
    filteredProjects() {
      return this.projects
        .filter((elem) => {
          let date = moment(elem.fecha_creacion).format("DD/MM/YYYY");
          let new_string_search = `${date.toLowerCase()} ${elem.id.toString()} ${elem.nombre.toLowerCase()}`;

          switch (this.statusFilter) {
            case "TODOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "RECHAZADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "RECHAZADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "NO REVISADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "NO REVISADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "EN REVISIÓN":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "EN REVISIÓN" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "APROBADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "APROBADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            return new Date(a.fecha_creacion) - new Date(b.fecha_creacion);
          } else {
            return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
          }
        });
    },
    filteredByAll() {
      return this.projects;
    },
    filteredByOpen() {
      return this.projects.filter((elem) => elem.status == "NO REVISADO");
    },
    filteredByAssigned() {
      return this.projects.filter((elem) => elem.status == "EN REVISIÓN");
    },
    filteredByCanceled() {
      return this.projects.filter((elem) => elem.status == "RECHAZADO");
    },
    filteredByAttended() {
      return this.projects.filter((elem) => elem.status == "APROBADO");
    },
    htmlToPdfOptions() {
      return {
        margin: 0,
    
        filename: `hehehe.pdf`,
    
        image: {
            type: 'jpeg', 
            quality: 0.98
        },
    
        enableLinks: false,
    
        html2canvas: {
            scale: 1,
            useCORS: true
        },
    
        jsPDF: {
            unit: 'in',
            format: 'a4',
            orientation: 'portrait'
        }
      }
    }
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
